import FalconCardHeader from "components/common/FalconCardHeader";
import { Card, Col, Row } from "react-bootstrap";

const PrescriptionStatusShimmer = () => {
  return (
    <Card className="h-100">
      <style>{`
        @keyframes shimmer {
          0% { background-position: -400px 0; }
          100% { background-position: 400px 0; }
        }
        .shimmer-box {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 800px 100%;
          animation: shimmer 1.4s infinite linear;
          border-radius: 6px;
        }
      `}</style>

      {/* Header */}
      <FalconCardHeader
        title="Prescription Status"
        light={false}
        titleTag="h6"
        className="pb-0"
      />

      <Card.Body className="pt-3">
        {/* Dropdown shimmer */}
        <Row className="mb-3">
          <Col>
            <div className="shimmer-box" style={{ height: '38px', width: '100%' }} />
          </Col>
        </Row>

        {/* Legend + Chart Row */}
        <Row className="align-items-center justify-content-between g-0">
          {/* Legend shimmer */}
          <Col xs={5}>
            <div className="mt-2">
              {/* Legend item 1 */}
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <div className="shimmer-box rounded-circle" style={{ width: '10px', height: '10px', flexShrink: 0 }} />
                  <div className="shimmer-box" style={{ width: '70px', height: '12px' }} />
                </div>
                <div className="shimmer-box" style={{ width: '55px', height: '12px' }} />
              </div>
              {/* Legend item 2 */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div className="shimmer-box rounded-circle" style={{ width: '10px', height: '10px', flexShrink: 0 }} />
                  <div className="shimmer-box" style={{ width: '55px', height: '12px' }} />
                </div>
                <div className="shimmer-box" style={{ width: '55px', height: '12px' }} />
              </div>
            </div>
          </Col>

          {/* Donut chart shimmer */}
          <Col xs="auto">
            <div style={{ position: 'relative', width: '8rem', height: '8rem' }}>
              {/* Outer ring */}
              <div style={{
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                backgroundSize: '800px 100%',
                animation: 'shimmer 1.4s infinite linear',
              }} />
              {/* Inner cutout to create donut */}
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '58%',
                height: '58%',
                borderRadius: '50%',
                backgroundColor: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                {/* Center text shimmer */}
                <div style={{ textAlign: 'center' }}>
                  <div className="shimmer-box mx-auto mb-1" style={{ width: '36px', height: '14px' }} />
                  <div className="shimmer-box mx-auto" style={{ width: '28px', height: '10px' }} />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default PrescriptionStatusShimmer;